<form [formGroup]="emailTemplateForm">
  <div class="dashboard-tile">
    <div class="tile-header">
      <div *ngIf="_emailTemplate?.id" class="tile-header-title">Update Email Template <span class="text-primary">{{_emailTemplate.subject}}</span></div>
      <div *ngIf="!_emailTemplate?.id" class="tile-header-title">New Email Template</div>
    </div>
    <div class="tile-content">
      <div class="formFieldList">
        <div style="padding-bottom:1.25em;">
          <mat-radio-group aria-label="Email Template Type" formControlName="type">
            <mat-radio-button value="INFORMATIONAL">Informational</mat-radio-button>
            <mat-radio-button value="MARKETING">Marketing</mat-radio-button>
            <mat-radio-button value="SYSTEM_ALERT">System Alert</mat-radio-button>
            <mat-radio-button value="NEW_ASSESSMENT">New Assessment</mat-radio-button>
            <mat-radio-button value="COMPLETED_ASSESSMENT">Completed Assessment</mat-radio-button>
          </mat-radio-group>
        </div>
        <mat-form-field>
          <mat-select placeholder="Theme" formControlName="theme" required>
            <mat-option value="connectwise">ConnectWise</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Subject" formControlName="subject" required>
        </mat-form-field>
        <mat-form-field>
          <input matInput placeholder="Sender" formControlName="sender" required>
        </mat-form-field>
        <mat-form-field>
          <textarea matInput placeholder="HTML Body" formControlName="htmlBody" required style="min-height:100px;"></textarea>
        </mat-form-field>
        <mat-form-field>
          <textarea matInput placeholder="Text Body" formControlName="textBody" required style="min-height:100px;"></textarea>
        </mat-form-field>
      </div>
      <div class="tile-footer">
        <button mat-button type="button" color="primary" (click)="cancel()">Cancel</button>
        <button [disabled]="emailTemplateForm.invalid" mat-raised-button type="submit" color="primary" (click)="saveEmailTemplate()">Save</button>
      </div>
    </div>
  </div>
</form>